import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { getUsers } from 'src/api/user'

const UserSearch = ({ placeholder, value, onChange, country = '' }) => {
  const [page, setPage] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const fetchUsers = async (searchValue = '', reset = false) => {
    if (loading || (!reset && !hasMore)) return

    setLoading(true)

    try {
      const currentPage = reset ? 0 : page
      const response = await getUsers(currentPage, 10, searchValue, country)

      if (response.data.length === 0) {
        setHasMore(false)
      }

      const usersList = response.data.map((element) => ({
        label: element.userName,
        value: element.userId,
      }))

      setUserData((prevUsers) => {
        const mergedUsers = reset ? usersList : [...prevUsers, ...usersList]
        return Array.from(
          new Map(mergedUsers.map((user) => [user.value, user])).values()
        )
      })

      setPage(reset ? 1 : currentPage + 1)
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  useEffect(() => {
    setPage(0)
    setHasMore(true)
    fetchUsers('', true)
  }, [country])

  return (
    <Select
      showSearch
      allowClear
      placeholder={placeholder}
      value={searchTerm || undefined}
      onSearch={(value) => {
        setSearchTerm(value)
        setPage(0)
        setHasMore(true)
        fetchUsers(value, true)
      }}
      onClear={() => {
        onChange(undefined)
        setSearchTerm('')
      }}
      onBlur={() => {
        if (!value) {
          setSearchTerm('')
        }
      }}
      onPopupScroll={(e) => {
        const bottom =
          e.currentTarget.scrollHeight ===
          e.currentTarget.scrollTop + e.currentTarget.clientHeight
        if (bottom && hasMore && !loading) {
          fetchUsers(searchTerm, false)
        }
      }}
      onChange={(selectedValue) => {
        onChange(selectedValue)
        setSearchTerm(
          userData.find((user) => user.value === selectedValue)?.label || ''
        )
      }}
      loading={loading}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : 'No users found'}
      style={{ marginLeft: 10, width: '200px' }}
    >
      {userData.map((user) => (
        <Select.Option key={user.value} value={user.value}>
          {user.label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default UserSearch
